'use client'

import { useEffect, useMemo } from 'react'

import { useGatewaySettingsStore } from '@/core/stores/gatewaySettingsStore'
import { getGatewayConfig } from '@/core/utils/gateway'
import { mergeGatewayUserSettings } from '@/core/utils/mergeGatewayUserSettings'

import { useGatewayUserSettings } from '../useGatewayUserSettings'

import { registerVisionUrlIfNeeded } from './utils/registerVisionUrlIfNeeded'

export function useRegisterVisionUrl() {
  const { host, port, isSecured } = getGatewayConfig()
  const { gatewaySettings } = useGatewayUserSettings()
  const hydrated = useGatewaySettingsStore((state) => state.hydrated)
  const config = useMemo(
    () => mergeGatewayUserSettings({ host, port, isSecured }, gatewaySettings),
    [gatewaySettings, host, isSecured, port]
  )

  useEffect(() => {
    if (!hydrated) {
      return
    }

    void registerVisionUrlIfNeeded(config)
  }, [config, hydrated])
}
